var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<pkp-tso-notice tso-name=\"tsoName\" ng-show=\"!!tsoNotice || !!leadTimeInfo\" notice=\"[tsoNotice + (!!leadTimeInfo ? ('<hr/>' + leadTimeInfo) : '')]\">\n</pkp-tso-notice>\n";
var id1="app/_directives/pkp-booking-deadline-notice.directive.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;